module.exports = __webpack_public_path__ + "static/media/ic_search.e13a4e92.svg";